import ToastComponent from './index.vue'
const Toast = {}
let baseUrl = 'https://4dscene.4dage.com/new4dkk/'
// 注册Toast
Toast.install = function (Vue) {
  // 生成一个Vue的子类
  // 同时这个子类也就是组件
  const ToastConstructor = Vue.extend(ToastComponent)
  // 生成一个该子类的实例
  const instance = new ToastConstructor()
  // 将这个实例挂载在我创建的p上
  // 并将此p加入全局挂载点内部
  instance.$mount(document.createElement('p'))
  document.body.appendChild(instance.$el)
  // 通过Vue的原型注册一个方法
  // 让所有实例共享这个方法
  let imgs = {
    success: baseUrl + 'images/icon/success.png',
    warn: baseUrl + 'images/icon/warn.png',
    error: baseUrl + 'images/icon/error.png'
  }
  Vue.prototype.$toast = {
    showConfirm: (type, msg, callback, cancal, comfirmtxt) => {
      // let langauge = localStorage.getItem('language')
      instance.img = imgs[type] || (baseUrl + 'images/icon/success.png')
      instance.message = msg
      instance.type = type
      instance.visible = true
      instance.toastType = 'comfirm'
      instance.diycomfirm = comfirmtxt
      instance.callback = callback || function () {
      }
      instance.cancal = cancal || function () {
      }
    },
    showLoading: () => {
      instance.isLoaing = true
    },
    show: (type, msg, callback) => {
      instance.img = imgs[type] || (baseUrl + 'images/icon/success.png')
      instance.message = msg
      instance.type = type
      instance.visible = true
      instance.toastType = 'show'
      instance.diycomfirm = ''
      instance.callback = callback || function () {
      }
    },
    showCapacityRecharge: (item, detail, deadline, type, callback) => {
      instance.capacitytype = type || 'recharge'
      instance.capacityvisible = true
      instance.capacityitem = item
      instance.capacitychildName = detail.snCode || (detail.childName && detail.childName.replace('4DKKPRO_', '')) || '--'
      instance.capacitydetail = detail

      instance.capacitycountry = detail.country
      instance.capacitydeadline = deadline
      instance.callback = callback || function () {}
    },
    showPointRecharge: (item, childName, id, callback) => {
      instance.ponintVisible = true
      instance.pointitem = item
      instance.pointchildName = childName
      instance.pointid = id
      instance.callback = callback || function () {}
    },
    showBinding: (val, callback) => {
      instance.bindingVisible = true
      instance.bindingType = val
      instance.callback = callback || function () {
      }
    },
    showInvoice: (item, callback) => {
      instance.editVisible = true
      instance.editItem = item
      instance.callback = callback || function () {
      }
    },
    showInvoiceDetail: item => {
      instance.showVisible = true
      instance.showItem = item
    },
    hideLoading: () => {
      instance.isLoaing = false
    },
    hideShow: () => {
      instance.visible = false
    }
  }
}
export default Toast



// WEBPACK FOOTER //
// ./src/components/toast/toast.js